import MultiSelect from "@/components/MultiSelect";

type GovernanceRoleFilterProps = {
  name: string;
  options: { value: string; label: string }[];
  selectedValues: string[];
  onSelect: (value: string, checked: boolean) => void;
  onClear: () => void;
};

export function GovernanceRoleFilter({ name, options, selectedValues, onSelect, onClear }: GovernanceRoleFilterProps) {
  if (options.length === 0) {
    return null;
  }

  return (
    <div data-name={name}>
      <MultiSelect
        label="Role"
        options={options}
        selectedValues={selectedValues}
        onSelect={onSelect}
        onClear={onClear}
        searchable={options.length > 8}
      />
    </div>
  );
}
